import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import PartnerStrip from "@/components/PartnerStrip";
import WhatsAppButton from "@/components/WhatsAppButton";
import MusicPlayer from "@/components/MusicPlayer";
import Landing from "@/pages/Landing";
import Home from "@/pages/Home";
import Movement from "@/pages/Movement";
import Voices from "@/pages/Voices";
import Gather from "@/pages/Gather";
import Gallery from "@/pages/Gallery";
import Register from "@/pages/Register";
import ConferenceRegister from "@/pages/ConferenceRegister";
import Admin from "@/pages/Admin";
import Journey from "@/pages/Journey";
import Launch from "@/pages/Launch";
import Reviews from "@/pages/Reviews";
import AdminReviews from "@/pages/AdminReviews";

const TITLES = {
  "/": "Choices & Decisions | Where Purpose Finds a Voice",
  "/home": "Choices & Decisions | Where Purpose Finds a Voice",
  "/movement": "The Movement | Choices & Decisions",
  "/voices": "Voices — To Parents, Schools & Young Women | Choices & Decisions",
  "/gather": "The Gathering 2026 | Choices & Decisions",
  "/gallery": "Gallery | Choices & Decisions",
  "/journey": "Our African Journey | Choices & Decisions",
  "/launch": "The Launch | Choices & Decisions",
  "/register": "Register Interest | Choices & Decisions",
  "/conference": "Conference Registration 2026 | Choices & Decisions",
  "/reviews": "Event Experience Reviews | Choices & Decisions",
};

function Layout({ children }) {
  const { pathname } = useLocation();
  const isLanding = pathname === "/";
  const bare = isLanding || pathname === "/admin" || pathname === "/admin/reviews";
  useEffect(() => {
    document.title = TITLES[pathname] || "Choices & Decisions | Where Purpose Finds a Voice";
  }, [pathname]);
  return (
    <>
      {!bare && <Nav />}
      <main>{children}</main>
      {!bare && <PartnerStrip />}
      {!bare && <Footer />}
      {!bare && <WhatsAppButton />}
      {pathname !== "/admin" && pathname !== "/admin/reviews" && <MusicPlayer />}
    </>
  );
}

function App() {
  return (
    <div className="App bg-ink">
      <BrowserRouter>
        <SmoothScroll>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/home" element={<Home />} />
              <Route path="/movement" element={<Movement />} />
              <Route path="/voices" element={<Voices />} />
              <Route path="/gather" element={<Gather />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/journey" element={<Journey />} />
              <Route path="/launch" element={<Launch />} />
              <Route path="/register" element={<Register />} />
              <Route path="/conference" element={<ConferenceRegister />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/admin/reviews" element={<AdminReviews />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Layout>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="top-center" theme="light" richColors />
    </div>
  );
}

export default App;
